import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
  },
  badgeContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
  },
  badge: {
    width: 'fit-content',
    borderRadius: '1rem',
    padding: '0.2rem 0.5rem',
    textAlign: 'center',
    fontWeight: '600',
    minWidth: '80px',
    color: 'white',
    fontSize: '0.75rem',
  },
}));

export default useStyles;
